import { createSelector } from '@ngrx/store';
import { E2E_TRACKING_ID_KEY } from '@analytics/utils';

import { selectFehHomebatteryState } from '../feh-homebattery.state';
import { homebatteryQuestionnaireKey } from './homebattery-questionnaire.reducer';
import { selectHomeBatteryFunnelSettings } from '../funnel/homebattery-funnel.selectors';

const selectHomebatteryQuestionnaire = createSelector(
  selectFehHomebatteryState,
  (state) => state[homebatteryQuestionnaireKey]
);

export const selectHomebatteryQuestionnaireStructure = createSelector(
  selectHomebatteryQuestionnaire,
  (state) => state.structure
);

export const selectHomebatteryQuestionnaireCurrentQuestion = createSelector(
  selectHomebatteryQuestionnaire,
  (state) => state.currentQuestion
);

export const selectHomebatteryQuestionnaireAnswers = createSelector(
  selectHomebatteryQuestionnaire,
  (state) => state.answers
);

export const selectHomebatteryQuestionnaireHasPreviousQuestion = createSelector(
  selectHomebatteryQuestionnaire,
  (state) => state.history.length > 0
);

export const selectHomebatteryQuestionnaireAnalyticsPayload = createSelector(
  selectHomebatteryQuestionnaireAnswers,
  selectHomeBatteryFunnelSettings,
  (answers, funnelSettings) => ({
    ...answers,
    [E2E_TRACKING_ID_KEY]: funnelSettings.trackingId,
  })
);
